import {Component, Input, OnInit} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'ngx-add-edit-preference-annual-program',
  templateUrl: './add-edit-preference-annual-program.component.html',
  styleUrls: ['./add-edit-preference-annual-program.component.scss'],
})
export class AddEditPreferenceAnnualProgramComponent implements OnInit {
  @Input() preference: any = {
    checked: true,
    element: '',
    frequency: 'diario',
    id: uuidv4(),
    name: '',
    type: 'limpiezas',
  };
  @Input() edit = false;

  constructor(
    protected ref: NbDialogRef<AddEditPreferenceAnnualProgramComponent>,
  ) { }

  ngOnInit() {
  }

  dismiss() {
    this.ref.close(false);
  }

  async create() {
    this.ref.close(this.preference);
  }

}
